import account from "./zh/account.json"
import aiDiagnose from "./zh/aiDiagnose.json"
import allCarManage from "./zh/allCarManage.json"
import base from "./zh/base.json"
import bookingManagement from "./zh/bookingManagement.json"
import common from "./zh/common.json"
import contractManagement from "./zh/contractManagement.json"
import dataManage from "./zh/dataManage.json"
import home from "./zh/home.json"
import homeMap from "./zh/homeMap.json"
import moveCarManage from "./zh/moveCarManage.json"
import orderManage from "./zh/orderManage.json"
import ordersManage from "./zh/ordersManage.json"
import index from "./zh/index.json"
import menu from "./zh/menu.json"
import newCommon from "./zh/newCommon.json"
import paper from "./zh/paper.json"
import shopOrder from "./zh/shopOrder.json"
import statistics from "./zh/statistics.json"
import statisticsIndex from "./zh/statisticsIndex.json"
import storeManagement from "./zh/storeManagement.json"
import tdms from "./zh/tdms.json"
import teamManage from "./zh/teamManage.json"
import stock from "./zh/stock.json"
import settings from "./zh/settings.json"
import purchase from "./zh/purchase.json"
import shopping from "./zh/shopping.json"
import sale from "./zh/sale.json"
import quickBilling from "./zh/quickBilling.json"
import components from "./zh/components.json"
import erpcomponents from "./zh/erpcomponents.json"
import orgManage from "./zh/orgManage.json"
import customerManage from "./zh/customerManage.json"
import dataDictionaries from "./zh/dataDictionaries.json"
import login from "./zh/Login.json"
import logs from "./zh/logs.json"
import permission from "./zh/permission.json"




const zhCN = {
  translation: {
    permission,
    logs,
    login,
    common,
    index,
    menu,
    aiDiagnose,
    bookingManagement,
    allCarManage,
    contractManagement,
    dataManage,
    home,
    homeMap,
    moveCarManage,
    orderManage,
    ordersManage,
    teamManage,
    tdms,
    storeManagement,
    statisticsIndex,
    statistics,
    shopOrder,
    account,
    base,
    paper,
    newCommon,
    stock,
    settings,
    purchase,
    shopping,
    sale,
    quickBilling,
    components,
    erpcomponents,
    orgManage,
    customerManage,
    dataDictionaries
  }
};

export default zhCN;
